import { 
    MY_ACCOUNT_USER_INFO_CLEAR_ERROR, 
    MY_ACCOUNT_USER_INFO_SUBMIT_ERROR, 
    MY_ACCOUNT_USER_INFO_RECEIVE, 
    MY_ACCOUNT_USER_INFO_LOAD_ERROR,
    MY_ACCOUNT_EMAIL_CHANGE_ERROR,
    MY_ACCOUNT_EMAIL_CLEAR_ERROR,
    MY_ACCOUNT_EMAIL_CHANGE_RECEIVE,
    MY_ACCOUNT_PASSWORD_CHANGE_ERROR,
    MY_ACCOUNT_PASSWORD_CLEAR_ERROR,
    MY_ACCOUNT_PASSWORD_CHANGE_RECEIVE
} from "../constants";
import { error as errorReducer } from './Error.reducer';

const defaultUserInfoState = {
    payload: {
        customerId: '',
        customerType: '',
        isBusinessCustomer: false,
        forceAddress: false,
        customerTypes: [],
        detailsModel: {
            firstName: '',
            lastName: '',
            address: '',
            zipCode: '',
            city: '',
            country: '',
            state: '',
            phoneNumber: '',
            companyName: '',
            vatNumber: ''
        }
    },
    errors: {}
}

export const myAccountUserInfo = (state = defaultUserInfoState, action) => {
    const { type, payload } = action;

    switch (type) {
        case MY_ACCOUNT_USER_INFO_SUBMIT_ERROR:
        case MY_ACCOUNT_USER_INFO_LOAD_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        case MY_ACCOUNT_USER_INFO_CLEAR_ERROR:
            return {
                ...state,
                ...payload,
            };
        case MY_ACCOUNT_USER_INFO_RECEIVE:
            return {
                ...state,
                payload: payload,
            }
        default:
            return state;
    }
}

export const myAccountChangeEmail = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case MY_ACCOUNT_EMAIL_CHANGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        case MY_ACCOUNT_EMAIL_CLEAR_ERROR:
            return {
                ...state,
                ...payload
            }
        case MY_ACCOUNT_EMAIL_CHANGE_RECEIVE:
            return {
                ...state,
                payload: payload,
            }
        default:
        return state;
    }
}

export const myAccountChangePassword = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case MY_ACCOUNT_PASSWORD_CHANGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        case MY_ACCOUNT_PASSWORD_CLEAR_ERROR:
        case MY_ACCOUNT_PASSWORD_CHANGE_RECEIVE:
            return {
                ...state,
                ...payload
            }
        default:
            return state;
    }
}